export interface HostBranding {
  productName: string
  subtitle: string
  markSrc: string
  faviconHref: string
}

const DEFAULT_BRANDING: HostBranding = {
  productName: 'Медцифра',
  subtitle: 'Платформа медицинской аналитики',
  markSrc: '/logo-icon.svg',
  faviconHref: '/favicon.svg',
}

const HOST_BRANDING: Array<{ pattern: RegExp; branding: HostBranding }> = [
  {
    pattern: /(^|\.)(adm|dev-adm)\.medcifra\.ru$/i,
    branding: {
      productName: 'Медцифра Админ',
      subtitle: 'Управление пользователями, доступами и справочниками',
      markSrc: '/favicon-auth.svg',
      faviconHref: '/favicon-auth.svg',
    },
  },
  {
    pattern: /(^|\.)(bi|dev-bi)\.medcifra\.ru$/i,
    branding: {
      productName: 'Медцифра BI',
      subtitle: 'Платформа медицинской аналитики',
      markSrc: '/favicon-bi.svg',
      faviconHref: '/favicon-bi.svg',
    },
  },
  {
    pattern: /(^|\.)id\.medcifra\.ru$/i,
    branding: {
      productName: 'Медцифра ID',
      subtitle: 'Единый контур аутентификации',
      markSrc: '/logo-icon.svg',
      faviconHref: '/favicon.svg',
    },
  },
]

export function getHostBranding(hostname: string): HostBranding {
  const normalized = hostname.toLowerCase()
  for (const item of HOST_BRANDING) {
    if (item.pattern.test(normalized)) {
      return item.branding
    }
  }
  return DEFAULT_BRANDING
}
